<template>
    <div class="">
        <div class="login-body py-3">
            <div class="d-flex justify-content-center align-items-center" style="height:100vh;">
                <div class="col-lg-4 col-md-6">
                    <div class="card shadow-sm text-center">
                        <div class="card-body px-lg-5 py-5">
                            <h5 class="font-weight-bold pb-4">Reset Password</h5>
                            <form @submit.prevent="sendPasswordResetLink()">
                                <div class="form-group mb-3 align-items-center justify-content-center">
                                    <!-- <label for="username" class="col-md-3 text-muted"> </label> -->
                                    <input class="form-control py-2 col-md-12 form-control-lg" v-model="form.email" placeholder="Email Address" type="text" required autofocus>
                                </div>
                                
                                <div class="">
                                    <div class="m-0 p-0">
                                        <button class="btn btn-custom btn-block btn-lg mb-3" type="submit">Send Reset link</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="d-flex mt-3 justify-content-center">
                        <p class="mr-3 ft-16">
                            <a class="text-muted" href="/">Home</a>
                        </p>
                        <p class="mr-3 ft-16">
                            <a class="text-muted" href="/login">Login</a>
                        </p>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name: 'ResetPassword',
    data() {
        return {
            form: {
                email: '',
            }
        }
    },
    methods: {
        async sendPasswordResetLink() {
            try {
                const response = await axios.post('/auth/forgot-password', { email: this.form.email});

                if (response.status == 200) {
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Password Reset Link has been sent to your mail.'
                    });
                }
                
            } catch (error) {

            }
        }
    }

}
</script>

<style>
.login-body {
    padding: 0;
    margin: 0;
    background: #F4EEF6;
    /* height: 100vh; */
    /* background: url('../assets/background.png'); */
    /* background-repeat: no-repeat; */
    /* background-size: cover; */
}
.card {
    background-color: #ffffffdb;
}
.ft-16 {
    font-size: 16px;
}

</style>